import { IWidgetSettings } from '../../reducers/widget'
import mapValuesToRequest from './mappers/mapValuesToRequest'
import handleResponse from './request/handleResponse'

export default function(api: GlobalFetch) {
  return async function(values: IWidgetSettings, objectId) {
    const requestBody = mapValuesToRequest(values, objectId)

    const response = await api.fetch('/api/v2/widget/index', {
      body: JSON.stringify(requestBody),
      method: 'POST',
    })

    // const response2 = await api.fetch('/api/v2/widget/', {
    //   body: JSON.stringify({
    //     id_object: objectId,
    //     subdomain: values.subdomain,
    //   }),
    //   method: 'PUT',
    // })

    return await handleResponse(response)
  }
}
